/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System Settings API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:37 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const EmailSettings = {
    all: () => requests.get('/EmailSettings'),
    get: emailsettingid => requests.get(`/EmailSetting/${emailsettingid}`),
    getByName: settingname => requests.get(`/EmailSettingByName?=name=${settingname}`),
    create: emailsetting => requests.post(`/EmailSettings`, emailsetting),
    update: (emailsettingid, emailsetting) => requests.put(`/EmailSetting/${emailsettingid}`, emailsetting),
    delete: emailsettingid => requests.del(`/EmailSetting/${emailsettingid}`),
};